<script setup lang="ts">
    import { computed } from 'vue';

    interface Props {
        text: string | null;
        color?: string;
        solid?: boolean;
        size?: 'sm' | 'md';
    }

    const props = withDefaults(defineProps<Props>(), {
        size: 'md',
        color: 'primary',
    });

    const backgroundColor = computed(() => {
        const alpha = props.solid ? 1 : 0.1;
        return {
            background: `rgba(var(--${props.color}), ${alpha})`,
        };
    });

    const textColor = computed(() => {
        return {
            color: props.solid ? `rgba(255,255,255,1)` : `rgba(var(--${props.color}), 1)`,
        };
    });
</script>

<template>
    <div
        class="focus-visible:border-ring focus-visible:ring-ring/50 inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-lg font-semibold whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3"
        :class="[
            size === 'sm' ? 'px-1.5 py-0.5 text-2xs' : 'px-2 py-0.5 text-xs',
        ]"
        :style="backgroundColor"
    >
        <span :style="textColor">
            {{ text }}
            <slot></slot>
        </span>
    </div>
</template>
